import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ActivationEnd, NavigationEnd, RoutesRecognized } from '@angular/router';
import { BaseComponentComponent } from '../../../library/components/components/common/base-component/base-component.component';
import { delay, filter, tap } from 'rxjs/operators/';

@Directive({
  selector: '[appRouterHide]'
})
export class RouterHideDirective extends BaseComponentComponent implements OnInit {

  protected originalDisplay: string;

  /**
   * Input for set the path of routes that should be matches for hide the host component.
   *
   * @type {Array<string>}
   * @memberof RouterHideDirective
   */
  @Input() pathsToBeHide: Array<string> = [];
  constructor(protected host: ElementRef, protected router: Router, protected _route: ActivatedRoute) {
    super();
    this.subscriptions.push(this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
    ).subscribe((next: NavigationEnd) => {
      const routes = next.url.split('?')[0].split('/');
      if (routes.findIndex(url => this.pathsToBeHide.indexOf(url) > -1) > -1) {
        this.host.nativeElement.style.visibility = 'hidden';
        this.host.nativeElement.classList.add('hide-route');

      } else {
        this.host.nativeElement.style.visibility = this.originalDisplay;
        this.host.nativeElement.classList.remove('hide-route');
      }
    }));
  }

  /**
   * {@inheritdoc}
   *
   * @memberof RouterHideDirective
   */
  ngOnInit() {
    super.ngOnInit();
    this.originalDisplay = this.host.nativeElement.style.visibility;
    const routesNow = this._route.snapshot['_routerState'].url.split('?')[0].split('/');
    if (routesNow.findIndex(url => this.pathsToBeHide.indexOf(url) > -1) > -1) {
      this.host.nativeElement.classList.add('hide-route');
      this.host.nativeElement.style.visibility = 'hidden';

    }
  }

}
